import React, { useState, useEffect } from "react";
import { VideoButton } from "../../utils/SvgComponents";
import CustomCard from "./card/Card";
import { EVENT_BASEURL } from "../../utils/Constants";

const GalleryCardMobile = ({
	color = "white",
	videoIconColor,
	id,
	data,
	title,
	cardBgImage,
	HandleOnclick,
	video = false,
	photos = false,
	isAlbum= true,
	slug,
	username,

}) => {

			const [isImageLoaded, setIsImageLoaded] = useState(true);

	const page = localStorage.getItem("photos_page");
	
		const hasVisited = localStorage.getItem("hasVisitedPhotosPage");
	
		useEffect(() => {
			const timer = window.location.pathname === `/photos/${id}` && setTimeout(() => {
				const hasVisited = localStorage.getItem("hasVisitedPhotosPage");
		  
				if (!hasVisited) {
				  localStorage.setItem("hasVisitedPhotosPage", "true");
				}
		  
				
			}, 3000); 
			return () => clearTimeout(timer);
		}, [page]);
		
	return (
		<div className="w-full mb-3">
			<div onClick={HandleOnclick}  className="pageOne-Card rounded-xl overflow-hidden relative whiteripple">
				<div  >
					<a
          href={`/${username}/GalleryImage/${id}/${slug}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block relative"
        >
					<img
						src={`${data?.cardBgImage}`}
						alt="card-image"
											onLoad={() => setIsImageLoaded(false)}
						  className={`relative h-[130px] w-full object-cover transition-all duration-500 ${
                    isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }`}
					/>
					
					<div className="absolute top-0 left-0 p-[20px] w-full h-full bg-black/40">
						<div
							style={{
								position: "absolute",
								top: "12%",
								bottom: "12%",
								left: "5%",
								right: "5%",
								zIndex: 3,
							}}
						>
							{["top", "bottom", "left", "right"].map((side) => (
									<div key={side} className={` ${page ? `${side}-border`: ''} ${hasVisited ? `${side}-border-active` : ""}`}></div>
								))}
						</div>
					</div>
					<div
						className=" absolute  mx-auto py-[7px] bottom-6 left-0 flex my-0 justify-center items-center w-full "
					>
						<p className='text-center text-white font-medium text-[21px] z-[1] pointer-events-none '>{data.title}</p>
					</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default GalleryCardMobile;
